export default __webpack_public_path__ + "static/media/people-white-small.1dce83ec.svg";